import { ContactForm } from "./ContactForm";
import { Mail, MapPin, Clock } from "lucide-react";

export function Contact() {
  return (
    <section id="contact" className="py-16 md:py-24" aria-labelledby="contact-heading">
      <div className="container">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h2 id="contact-heading" className="text-3xl md:text-4xl font-display font-bold text-secondary mb-4">
            Get In Touch
          </h2>
          <p className="text-lg text-muted-foreground">
            Ready to start your learning journey? Send us a message and we'll get back to you.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          <div className="bg-card rounded-2xl p-8 shadow-card border border-border">
            <h3 className="text-xl font-display font-bold text-secondary mb-6">Send us a message</h3>
            <ContactForm />
          </div>

          <div className="flex flex-col gap-6">
            <div className="bg-muted/50 rounded-2xl p-8">
              <h3 className="text-xl font-display font-bold text-secondary mb-6">Contact Details</h3>
              
              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                    <Mail className="h-5 w-5 text-primary" aria-hidden="true" />
                  </div>
                  <div>
                    <p className="font-medium text-secondary">Email</p>
                    <a 
                      href="mailto:info@upgradeskills.org" 
                      className="text-muted-foreground hover:text-primary transition-colors"
                    >
                      info@upgradeskills.org
                    </a>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                    <MapPin className="h-5 w-5 text-primary" aria-hidden="true" />
                  </div>
                  <div>
                    <p className="font-medium text-secondary">Address</p>
                    <address className="text-muted-foreground not-italic">
                      CEME Campus, Marsh Way,<br />
                      Rainham, Essex, RM13 8EU
                    </address>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                    <Clock className="h-5 w-5 text-primary" aria-hidden="true" />
                  </div>
                  <div>
                    <p className="font-medium text-secondary">Opening Hours</p>
                    <p className="text-muted-foreground">
                      Monday to Saturday<br />
                      10:00am – 5:00pm
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-navy rounded-2xl p-8 text-secondary-foreground">
              <h3 className="text-xl font-display font-bold mb-4">Prefer email?</h3>
              <p className="mb-4 opacity-90">
                You can reach us directly at info@upgradeskills.org and we'll respond within one working day.
              </p>
              <a
                href="mailto:info@upgradeskills.org"
                className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-lg font-medium hover:opacity-90 transition-opacity"
              >
                <Mail className="h-4 w-4" aria-hidden="true" />
                Message us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}